// Which fusion_documents rows are LIVE — i.e. actually being asked of
// suppliers right now.
//
// Two columns describe a document's life and they are not interchangeable:
//
//   status     'draft' | 'active' | 'archived' | 'superseded'  — the real
//              lifecycle. Publishing sets it to 'active'.
//   is_active  boolean DEFAULT true (2026-04-april-enhancements.sql)
//
// The default is the trap. A document created and left as a DRAFT is born
// with is_active = true, so a query filtering on is_active alone returns
// unpublished drafts as though they were live requirements. That is where
// "Low risk · 12 documents required" and 9 phantom outstanding documents came
// from: drafts nobody had ever published were counted against suppliers, and
// SupplierDetail's auto-publish effect then stamped sent_at on them.
//
// status is tolerated as NULL because rows predating the status column exist;
// those are legacy live documents, not drafts.
export const applyLiveDocumentFilter = (query) =>
  query.eq('is_active', true).or('status.is.null,status.neq.draft');

// The same rule applied to rows already in memory, for callers that have
// fetched the documents and need to filter or intersect client-side.
export const isLiveDocument = (row) =>
  !!row && row.is_active !== false && row.status !== 'draft';

// A requirement is only real if the document it points at is live. Requirement
// rows in risk_document_requirements outlive the documents they name — a key
// whose document was archived, deleted or never published still sits in the
// table and would otherwise be counted and chased.
//
// requiredKeys: Set|Array of document_key. liveKeys: Set|Array of the keys
// that exist and are live. Returns a Set.
export const liveRequiredKeys = (requiredKeys, liveKeys) => {
  const live = liveKeys instanceof Set ? liveKeys : new Set(liveKeys || []);
  const out = new Set();
  for (const k of (requiredKeys || [])) if (live.has(k)) out.add(k);
  return out;
};
